import { AnimatePresence, motion } from 'framer-motion'
import { ReactNode, Suspense, lazy } from 'react'

import Lottie from 'lottie-react'

import spinnerNormalLottie from '@assets/v2/loading.json'
import spinnerCheckLottie from '@assets/v2/loading-check.json'

const HouseAnimation = lazy(() => import('./HouseAnimation'))

interface LoadingProps {
  spinner?: 'normal' | 'check'
  loadingMessage: ReactNode
  successMessage: ReactNode
  isSuccessful?: boolean
  showHouse?: boolean
}

export const Loading = ({
  spinner = 'normal',
  loadingMessage,
  successMessage,
  isSuccessful = false,
  showHouse = true
}: LoadingProps) => {
  return (
    <div
      className={`flex h-full flex-col items-center font-myriad ${
        !showHouse && 'justify-center'
      }`}
    >
      {showHouse && (
        <div className="w-full max-w-[278px] mt-2">
          <Suspense fallback={<div />}>
            <HouseAnimation />
          </Suspense>
        </div>
      )}

      <Lottie
        animationData={
          spinner === 'check' ? spinnerCheckLottie : spinnerNormalLottie
        }
        className="w-12 h-12 -mt-2 xl:w-12 xl:h-12"
      />

      <div className="w-full relative mt-5">
        <AnimatePresence>
          {!isSuccessful && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 0 }}
              transition={{ duration: 1 }}
              className="w-full text-xs text-center font-semibold tracking-wide uppercase top-0 left-0"
            >
              {loadingMessage}
            </motion.div>
          )}
        </AnimatePresence>

        <AnimatePresence>
          {isSuccessful && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 1 }}
              className="w-full text-xs text-center font-semibold tracking-wide uppercase top-0 left-0"
            >
              {successMessage}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}
